/** @format */

import './App.css';
import FAQ from './components/FAQ';
import Financing from './components/Financing';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import TermsConditions from './components/TermsConditions';

function App() {
	return (
		<div className='App'>
			<Navbar />
			<TermsConditions />
			<FAQ />
			<Financing />
			<Footer />
		</div>
	);
}

export default App;
